/* A configurable PC's offer must describe its validated full build, not its case. */
(() => {
  'use strict';
  const node = document.querySelector('[data-elite-configurable-product]');
  if (!node) return;
  let product;
  try { product = JSON.parse(node.textContent); } catch { return; }
  // Review pagination can complete after this script starts. Keep these fields
  // in the cached Product object when compatibility/price updates rewrite it.
  document.addEventListener('elite:product-reviews:updated', event => {
    if (event.detail?.productId !== node.dataset.eliteReviewProductId) return;
    let updated;
    try { updated = JSON.parse(node.textContent); } catch { return; }
    for (const key of ['aggregateRating', 'review']) {
      if (updated[key]) product[key] = updated[key];
      else delete product[key];
    }
  });
  const write = () => { node.textContent = JSON.stringify(product).replace(/</g, '\\u003c'); };
  window.ElitePCSEO = {
    clear() { if (product.offers) { delete product.offers; write(); } },
    update(validation, selection) {
      const price = validation?.price;
      if (validation?.success !== true || validation.compatible !== true || validation.checkoutReady !== true
        || price?.currency !== 'GBP' || typeof price.amount !== 'number' || !Number.isFinite(price.amount) || price.amount <= 0
        || typeof validation.build?.allComponentsInStock !== 'boolean') {
        this.clear(); return;
      }
      const url = new URL(location.href);
      // Keep the exact configuration that produces the displayed quote.
      for (const key of [...url.searchParams.keys()]) if (!/^(?:pc$|elite_|component_)/.test(key)) url.searchParams.delete(key);
      url.hash = '';
      product.offers = {
        '@type':'Offer', url:url.href, price:price.amount.toFixed(2), priceCurrency:'GBP',
        itemCondition:'https://schema.org/NewCondition',
        availability:'https://schema.org/' + (validation.build.allComponentsInStock ? 'InStock' : 'OutOfStock'),
        seller:{'@id':location.origin+'/#organization'},
        shippingDetails:{'@type':'OfferShippingDetails',shippingDestination:{'@type':'DefinedRegion',addressCountry:'GB'},
          shippingRate:{'@type':'MonetaryAmount',value:0,currency:'GBP'},
          deliveryTime:{'@type':'ShippingDeliveryTime',handlingTime:{'@type':'QuantitativeValue',minValue:1,maxValue:1,unitCode:'DAY'},transitTime:{'@type':'QuantitativeValue',minValue:2,maxValue:4,unitCode:'DAY'}}},
        hasMerchantReturnPolicy:{'@type':'MerchantReturnPolicy',applicableCountry:'GB',returnPolicyCategory:'https://schema.org/MerchantReturnFiniteReturnWindow',merchantReturnDays:30,returnMethod:'https://schema.org/ReturnByMail',returnFees:'https://schema.org/FreeReturn',merchantReturnLink:location.origin+'/pages/shipping-returns'}
      };
      // Component SKUs and the case GTIN do not identify the assembled PC.
      if (selection?.selections) product.additionalProperty = Object.entries(selection.selections).filter(([,value])=>typeof value==='string'&&value).map(([name,value])=>({'@type':'PropertyValue',name,value}));
      write();
    }
  };
})();
